const INIT = 'project/init';
const LOAD = 'project/load';

const CREATE_FOLDER = 'project/create-folder';
const EDIT_FOLDER = 'project/edit-folder';
const DELETE_FOLDER = 'project/delete-folder';

const CREATE_NOTE = 'project/folder/create-note';
const EDIT_NOTE = 'project/folder/edit-note';
const DELETE_NOTE = 'project/folder/delete-note';

const CREATE_TASK = 'project/folder/create-task';
const EDIT_TASK = 'project/folder/edit-task';
const DELETE_TASK = 'project/folder/delete-task';
const START_TASK = 'project/folder/start-task';
const RESOLVE_TASK = 'project/folder/resolve-task';
const REJECT_TASK = 'project/folder/reject-task';
const REOPEN_TASK = 'project/folder/reopen-task';

const TIMER_TRACK_TASK = 'project/timer/track-task';
const TIMER_STARTNEXT_TASK = 'project/timer/start-task';
const TIMER_STOP_TASK = 'project/timer/stop-task';
const TIMER_CLEAR_TASK = 'project/timer/clear-task';

const RECENTS_TOUCH = 'project/recents/touch';
const RECENTS_DELETE = 'project/recents/delete';

const SET_SEARCH_DATA = 'project/search/set-data';

const TOAST_MSG = 'project/toast/msg';

export { 
    INIT, 
    LOAD, 
    
    CREATE_FOLDER, 
    EDIT_FOLDER, 
    DELETE_FOLDER,

    CREATE_NOTE, 
    EDIT_NOTE, 
    DELETE_NOTE,
    
    CREATE_TASK, 
    EDIT_TASK, 
    DELETE_TASK,
    START_TASK,
    RESOLVE_TASK,
    REJECT_TASK,
    REOPEN_TASK,

    TIMER_TRACK_TASK,
    TIMER_STARTNEXT_TASK,
    TIMER_STOP_TASK,
    TIMER_CLEAR_TASK,

    RECENTS_TOUCH,
    RECENTS_DELETE,

    SET_SEARCH_DATA,

    TOAST_MSG
};